import { createReduxStore } from '../../utils/redux/createStore';
import { IAppInitialState } from '../../types';

import { TContextParams } from './types';

/**
 * Сервис, для подготовки состояния приложения.
 * Этот сервис является управляющим, т.е. именно он должен обращаться к
 * другим сервисам за данными.
 *
 * Чтобы код сервиса не разрастался, рекомендуется разделять его на небольшие
 * функции.
 *
 * @export
 * @param context
 * @param params
 * @param initialState
 * @param debugEnabled
 * @returns {Store<IApplicationState, TReduxActions>}
 */
export const createAppState = (context: TContextParams, initialState: IAppInitialState) => {
  const { httpApi, logger, config, telemetry, webview, appEvent, paymentWidgetMicrofrontend, payPackageMicrofrontend } =
    context;

  const store = createReduxStore(initialState, {
    httpApi,
    config,
    logger,
    telemetry,
    webview,
    appEvent,
    paymentWidgetMicrofrontend,
    payPackageMicrofrontend,
  });

  return store;
};
